import { ICssShadow } from './../ICssShadow.interface';
import { SeCommonConfig } from './../SeCommonConfig.class';
import { IBaseSEConfig } from '../base-se-config.interface';
import * as _ from 'lodash';

export class SeLiveVideoConfig extends SeCommonConfig implements IBaseSEConfig {

  // settings just for this element
  public SeType = 'SeLiveVideo';

  public mute: boolean;
  public isLive: boolean;
  public playList: Array<string> = new Array();
  public streamAddress: string;
  public isLocal: boolean;
  public streamType: string;
  public volume: number;
  public poster = '';
  public isYoutubeVideo = true;
  public youtubeId: string;
  public autoplayInDesigner = false;

  constructor(jsonString?: string) {
    super();
    if (jsonString) {
      this.fromJsonString(jsonString);
    }
  }

  // create json from class vars
  toJson() {
    const obj = super.toJson(); // process common base config settings
    obj.SeType = this.SeType;
    obj.mute = this.mute;
    obj.streamAddress = this.streamAddress;
    obj.isLocal = this.isLocal;
    obj.streamType = this.streamType;
    obj.isLive = this.isLive;
    obj.volume = this.volume;
    obj.poster = this.poster;
    obj.isYoutubeVideo = this.isYoutubeVideo;
    obj.youtubeId = this.youtubeId;
    obj.autoplayInDesigner = this.autoplayInDesigner;

    return obj;
  }

  // parse json to class vars
  fromJson(obj) {
    super.fromJson(obj); // process common base config settings
    this.mute = _.get(obj, 'mute', null);
    this.streamAddress = _.get(obj, 'streamAddress', '');
    this.streamType = _.get(obj, 'streamType', '');
    this.isLocal = _.get(obj, 'isLocal', true);
    this.isLive = _.get(obj, 'isLive', false);
    this.poster = _.get(obj, 'poster', '');
    this.isYoutubeVideo = _.get(obj, 'isYoutubeVideo', false);
    this.youtubeId = _.get(obj, 'youtubeId', '');
    this.autoplayInDesigner = _.get(obj, 'autoplayInDesigner', '');
    this.volume = _.get(obj, 'volume', this.isYoutubeVideo ? 50 : .5);
  }

  toJsonString() {
    return JSON.stringify(this.toJson());
  }

  fromJsonString(str) {
    this.fromJson(JSON.parse(str));
  }


}



// WEBPACK FOOTER //
// ./src/app/backend-main.module/pages/designer.module/screen-elements.module/se-live-video/se-live-video-config.class.ts